import { TimeOptionList as e } from "./TimeOptionList.mjs";
import { TimePanel as t } from "./TimePanel.mjs";
import "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/TimePicker/components/TimePickerPanel.tsx
var r = ({ value: r, step: i, list: a, onChange: o, onCommit: s }) => a ? /* @__PURE__ */ n(e, {
	value: r,
	step: i,
	options: a,
	onPick: (e) => {
		o(e), s();
	}
}) : /* @__PURE__ */ n(t, {
	value: r,
	step: i,
	onChange: o
});
//#endregion
export { r as TimePickerPanel };
